import React from 'react';
import { Link } from 'react-router-dom';

import './toolbar-btn.scss';

import { Svg } from '~shared/ui';

export interface ToolbarBtnProps {
	to?: string;
	onClick?: () => void;
	title: string;
	icon1: string;
	icon2?: string;
}

export const ToolbarBtn: React.FC<ToolbarBtnProps> = ({ to, title, icon1, icon2, onClick }) => {
	if (to)
		return (
			<Link to={to} className={`btn toolbar-btn`} onClick={onClick}>
				<span>{title}</span>
				<div className="icon">
					<i className="fa-remove">
						<Svg name={icon1} />
					</i>
					<i className="fa-check">
						<Svg name={icon2 ?? icon1} />
					</i>
				</div>
			</Link>
		);

	return (
		<button className={`btn toolbar-btn`} onClick={onClick}>
			<span>{title}</span>
			<div className="icon">
				<i className="fa-remove">
					<Svg name={icon1} />
				</i>
				<i className="fa-check">
					<Svg name={icon2 ?? icon1} />
				</i>
			</div>
		</button>
	);
};
